import "../Style/__login.scss";
import React, { useEffect, useState } from "react";
// import '../Form/LoginDesign.css'
import foto1 from "../Form/img/photo.svg";
import logo from "../Images/accountreelogo.png";
import axios from "axios";
import AuthForm from "./AuthForm";
import { saveToken } from "./HandleJWT";
import { useHistory } from "react-router-dom";
import { errorAlert, fiscalYearAlert, infoAlert } from "../Components/Alerts";
import { ApiLink } from "../APILink/ApiLink";
import "../Style/Button.css";
import { useLicense } from "../GetData/Context/LicenseContext";
import { startInactivityLogout } from "./inactivityService";

const THEME_STORAGE_KEY = "accountree-theme";
const WORLD_CUP_START_DATE = new Date("2026-06-11T00:00:00");
const WORLD_CUP_END_DATE = new Date("2026-07-20T00:00:00");
const WORLD_CUP_LOGO_URL =
  "https://logowik.com/content/uploads/images/copa-mundial-de-la-fifa-20265186.logowik.com.webp";

const resolveStoredTheme = () => {
  if (typeof window === "undefined") {
    return "light";
  }

  const storedTheme = localStorage.getItem(THEME_STORAGE_KEY);
  if (storedTheme === "dark") {
    return "dark-green";
  }

  return storedTheme || "light";
};

export default function Login() {
  // const [errors, setErrors] = useState([]);
  // const { update } = useContext(AuthenticationContext);
  const { setLicenseInfo } = useLicense();

  const history = useHistory();

  const [licenseMessage, setLicenseMessage] = useState(null);
  const [licenseType, setLicenseType] = useState(null); // "error" | "warning"
  const [showWorldCupBanner, setShowWorldCupBanner] = useState(false);

  useEffect(() => {
    const storedTheme = resolveStoredTheme();
    const isDarkTheme = storedTheme !== "light";
    const themeVariant = storedTheme === "dark-black" ? "black" : "green";

    document.documentElement.setAttribute("data-theme", isDarkTheme ? "dark" : "light");
    document.documentElement.setAttribute(
      "data-theme-variant",
      isDarkTheme ? themeVariant : "light"
    );
    document.documentElement.style.colorScheme = isDarkTheme ? "dark" : "light";

    const today = new Date();
    setShowWorldCupBanner(
      today >= WORLD_CUP_START_DATE && today < WORLD_CUP_END_DATE
    );
  }, []);

  //Ky kod ka qen aktiv, deri ne kohen kur fillova me i testu licensat
  // const login = async (credentials, setLoading) => {
  //   try {
  //     const res = await axios.post(ApiLink.API_URL + 'AuthProva/login', credentials);
  //     saveToken(res.data);
  //     history.push('/dashboard');
  //     window.location.reload();
  //   } catch (error) {
  //     if (error.response && error.response.status === 400) {
  //       errorAlert('Incorrect Email or Password');
  //     } else {
  //       errorAlert(error);
  //     }
  //   } finally {
  //     setLoading(false); // Reset loading state
  //   }
  // };

  const login = async (credentials, setLoading) => {
    try {
      const res = await axios.post(
        ApiLink.API_URL + "AuthProva/login",
        credentials
      );

      saveToken(res.data);
      setLicenseInfo({
        status: res.data.LicenseStatus,
        daysLeft: res.data.DaysLeft,
      });

      // console.log(res.data.DaysLeft);

      startInactivityLogout(history);
      history.push("/dashboard");

      // ⚠️ Paralajmërim për skadim
      if (res.data.licenseStatus === "ExpiringSoon") {
        setLicenseMessage(
          `Licenca juaj skadon për ${res.data.daysLeft} ditë. Ju lutemi kontaktoni për rinovim.`
        );
        setLicenseType("warning");
      } else {
        setLicenseMessage(null);
        setLicenseType(null);
      }
      window.location.reload();
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;

        // ❌ Kredenciale gabim
        if (status === 400) {
          errorAlert(data?.message || "Incorrect Email or Password");
          return;
        }

        // ❌ Licencë e skaduar / bllokuar
        if (status === 403) {
          fiscalYearAlert(`${data?.message}, ju lutem kontaktoni administratorin info@quantifynexus.com`|| "Licenca nuk është aktive.");
          // infoAlert("error");
          return;
        }

        errorAlert(data?.message || "Gabim në server.");
      } else {
        errorAlert("Nuk ka lidhje me serverin.");
      }
    } finally {
      setLoading(false);
    }
  };

  // const onSubmitHandler = (data) => {
  //   login(data)
  // }

  const onSubmitHandler = (data, setLoading) => {
    setLoading(true);
    login(data, setLoading);
  };

  return (
    <>
      <div className="Login_container">
        <div className="Login_forms-container">
          <div className="Login_signin-signup">
            <div className="sign-in-form">
              {showWorldCupBanner && (
                <div className="Login_world-cup-logo" aria-label="FIFA World Cup 2026">
                  <img
                    src={WORLD_CUP_LOGO_URL}
                    alt="FIFA World Cup 2026"
                    loading="lazy"
                  />
                </div>
              )}
              <a
                className="Login_form-badge"
                href="https://acctree.net"
              >
                Faqja Kryesore
              </a>
              <div className="logo">
                <img src={logo} alt="webscript" />
              </div>
              <h1 className="Login_title">Mirë se u kthyet</h1>
              <p className="Login_subtitle">
                Hyni në platformë për të menaxhuar financat dhe raportet në një
                vend të vetëm.
              </p>
              {licenseMessage && (
                <div className={`Login_notice Login_notice--${licenseType || "warning"}`}>
                  {licenseMessage}
                </div>
              )}
              {/* <DisplayErrors errors={errors} /> */}
              <AuthForm
                model={{ email: "", password: "" }}
                onSubmit={onSubmitHandler}
              />
              <a
                className="Login_footer-note"
                href="https://www.quantifynexus.com"
              >
                Developed by Quantify Nexus LLC
              </a>
            </div>
          </div>
        </div>

        <div className="panels-container">
          <div className="panel left-panel">
            <div className="Login_content">
              <div className="Login_h3">
                <h3>Thjeshtoni kontabilitetin, përforconi suksesin tuaj.</h3>
                {/* <h3 >Simplify your accounting, amplify your success.</h3> */}
              </div>
              {/* <p>
                Accountree is designed to simplify the accounting process for businesses of all sizes. With features like real-time reporting and automatic bank feeds, our software streamlines financial management so you can focus on growing your business!
              </p> */}
              <p>
                Accountree është zhvilluar për të bërë më të lehtë procesin e
                kontabilitetit për bizneset e çdo kategorie. Me karakteristika
                si raportim në kohë reale nga çdo lloj paisjesh, aplikacioni ynë
                bën më të lehtë menaxhimin financiar, duke u përqëndruar në çdo
                lëvizje të biznesit tuaj!
              </p>
              <div className="Login_highlights">
                <span>Raportim në kohë reale</span>
                <span>Siguri e avancuar</span>
                <span>Kontroll i plotë i biznesit</span>
              </div>
              {/* <button className="Login_btn transparent" id="sign-up-btn">
                Learn more
              </button> */}
            </div>
            <img src={foto1} className="image" alt="" />
          </div>
        </div>
      </div>
    </>
  );
}
